import React, { useState, useEffect } from 'react';

import axios from '../../../AxiosInstance';
import useNotification from '../../../components/notification';
export const CategoriesContext = React.createContext();

export const CategoriesProvider = ({ children }) => {
  const { sendNotification } = useNotification();
  const [editModal, setEditModal] = useState(false);
  const [editCategory, setEditCategory] = useState({});
  const [selected, setSelected] = useState(null);
  const [categoriesTree, setCategoriesTree] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    axios
      .get('/categories')
      .then((res) => setCategoriesTree(res.data))
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };

  const editCategorySubmit = (values) => {
    console.log(values);
    if (typeof editCategory.id === 'undefined') {
      const newCat = {
        name: values.name,
        description: values.description,
        slug: values.slug,
      };
      if (values.parentId) newCat.parentId = values.parentId;
      axios
        .post('/categories', newCat)
        .then((res) => {
          sendNotification({ msg: 'Add new category success', variant: 'success' });
          setEditModal(false);
          fetchCategories();
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: 'Something wrong open console', variant: 'error' });
        });
    } else {
      const editCat = {
        name: values.name,
        description: values.description,
        slug: values.slug,
      };
      axios
        .put(`/categories/${editCategory.id}`, editCat)
        .then((res) => {
          sendNotification({ msg: 'Edit category success', variant: 'success' });
          setEditModal(false);
          fetchCategories();
        })
        .catch((err) => {
          console.error(err);
          sendNotification({ msg: 'Something wrong open console', variant: 'error' });
        });
    }
  };

  const handleSelect = (e, nodeId) => {
    // console.log(nodeId);
    let result = null;
    for (let parent of categoriesTree) {
      result = dfs(parent, nodeId);
      if (result) {
        break;
      }
    }
    // console.log(result);
    setSelected(result);
  };

  const findCategoryNode = (nodeId) => {
    let result = null;
    for (let parent of categoriesTree) {
      result = dfs(parent, nodeId);
      if (result) {
        break;
      }
    }
    return result;
  };

  const dfs = (obj, targetId) => {
    if (obj.id === targetId) {
      return obj;
    }
    if (obj.children) {
      for (let item of obj.children) {
        let check = dfs(item, targetId);
        if (check) {
          return check;
        }
      }
    }
    return null;
  };

  const handleEditCategory = () => {
    // console.log(selected);
    let parentNode = findCategoryNode(selected.parentId);
    // console.log(parentNode, 'parent');
    setEditCategory({
      ...selected,
      parentId: parentNode?.id,
      parent_name: parentNode ? parentNode.name : 'No Parent Category',
    });
    // console.log({ ...selected, parent: parentNode, parent_name: parentNode?.name });
    setEditModal(true);
  };

  const handleAddCategory = () => {
    if (selected) setEditCategory({ parentId: selected.id, parent_name: selected.name });
    else setEditCategory({ parentId: null, parent_name: 'No Parent' });
    // console.log({ parent: selected, parent_name: selected.name });
    setEditModal(true);
  };

  const handleDeleteSelected = () => {
    setSelected(null);
  };

  const handleDeleteSubmit = () => {
    axios
      .delete(`/categories/${selected.id}`)
      .then((res) => {
        sendNotification({ msg: 'delete success', variant: 'success' });
        fetchCategories();
      })
      .catch((err) => {
        console.error(err);
        sendNotification({ msg: 'Something wrong open console', variant: 'error' });
      });
  };

  return (
    <CategoriesContext.Provider
      value={{
        categoriesTree,
        handleSelect,
        selected,
        editModal,
        setEditModal,
        handleEditCategory,
        editCategorySubmit,
        editCategory,
        setEditCategory,
        handleDeleteSubmit,
        handleAddCategory,
        handleDeleteSelected,
      }}>
      {children}
    </CategoriesContext.Provider>
  );
};
